import React, { FC, ReactElement } from 'react';

import { useDashboardContext } from 'src/shared/contexts';
import LoadingIndicator from 'src/shared/loading-indicator';

import { DashboardCard } from '../dashboard-card/dashboard-card';
import { DashboardNumericValue } from '../dashboard-numeric-value/dashboard-numeric-value';
import { useTranslation } from 'react-i18next';

interface Props {
    title: string;
    editMode: boolean;
    isShown?: boolean;
    handleChangeShown?: (name: string, value: boolean) => void;
    name?: string;
    amount: number;
}

export const DashboardContractsActiveAmount: FC<Props> = ({
    title,
    editMode,
    isShown,
    handleChangeShown,
    name,
    amount,
}): ReactElement => {
    const { t } = useTranslation(['common']);
    const { isGetDashboardDataLoading } = useDashboardContext();

    return (
        <DashboardCard
            header={title}
            editMode={editMode}
            isShown={isShown}
            handleChangeShown={handleChangeShown}
            name={name}
        >
            {!isGetDashboardDataLoading ? (
                <DashboardNumericValue value={amount} unit={t('common:contracts')} />
            ) : (
                <LoadingIndicator />
            )}
        </DashboardCard>
    );
};
